import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { OneOrManyFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { INotificationList, NotificationStatus } from "../types";

export interface INotificationListQueryParameters extends IPaginateable {
    filters?: {
        status?: OneOrManyFilter<NotificationStatus>;
    };
}

export type INotificationListQueryResult = INotificationList;

const mapFilters = (filters: INotificationListQueryParameters["filters"]) => {
    const { status } = filters ?? {};
    return {
        status,
    };
};

export const notificationListQuery: IApiQueryFunction<INotificationListQueryParameters> = ({
    filters,
    pagination,
}) => ({
    method: "GET",
    url: `/notifications${serialize(
        {
            ...mapPagination(pagination),
            ...mapFilters(filters),
        },
        true,
    )}`,
});

export const useNotificationListQuery = createApiQueryHook<
    INotificationListQueryParameters,
    INotificationListQueryResult
>(notificationListQuery);
